import React from 'react';
/* import { Button, Typography } from 'antd'; */
import { BarChartOutlined, ExportOutlined, TeamOutlined } from '@ant-design/icons';
import { Card } from 'components/card/card';
import { HeaderTitleButtons } from '../../../shared-components/header-title-buttons';
import styles from './parent-card-container.module.scss';

export const ParentCardContainer = ({ children }) => {
  return <Card className={styles.card_container}>{children}</Card>;
};

ParentCardContainer.Header = ({ title = 'Department Analytics', isVisible, onToggleVisibility, onExportData }) => {
  return (
    <div className={styles.card_header}>
      <div className={styles.header_content}>
        <HeaderTitleButtons
          title={title}
          titleIcon={<BarChartOutlined className={`${styles.header_icon} text-navy-blue-100`} />}
          titleLevel={4}
          button1Text={isVisible ? 'Hide Team Analytics' : 'Show Team Analytics'}
          button1Icon={<TeamOutlined />}
          button1Type="default"
          isButtonsShowed
          button1OnClick={onToggleVisibility}
          button2Text="Export Data"
          button2Icon={<ExportOutlined />}
          button2Type="default"
          button2OnClick={onExportData}
        />
      </div>
    </div>
  );
};

ParentCardContainer.Content = ({ children }) => {
  return <div className={styles.card_content}>{children}</div>;
};

ParentCardContainer.Footer = ({ text = 'Managing SPOT Team leads and workload distribution' }) => {
  return (
    <div className={styles.card_footer}>
      <span className={styles.footer_text}>{text}</span>
    </div>
  );
};

export default ParentCardContainer;
